import { useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import GulfStudents2 from "../../../Assets/Gulf_Students/Pre-Departure-Toolkit-For-Gulf-Students.webp"
import GulfStudentsData from "../../../Data/Gulf_Students/GulfStudentsData"
import PreDepartureToolkitData from "../../../Data/Gulf_Students/Services_Data/PreDepartureToolkitData"
import PreDepartureTestimonialData from "../../../Data/Gulf_Students/Testimonial_Data/PreDepartureTestimonialData"
import "../../CSS/GulfStudentsCSS.css"
import "../../CSS/GulfStudentsForm.css"
import TestimonialCard from "../TestimonialCard"

const PreDepartureToolKit = () => {
    const navigate = useNavigate();
    const [stuName, setStuName] = useState();
    const [email, setEmail] = useState();
    const [departure, setDeparture] = useState();
    const [origin, setOrigin] = useState();
    const [destination, setDestination] = useState();
    const [university, setUniversity] = useState();
    const handleSubmit = (e) => {
        if (!stuName || !email || !departure || !origin || !destination || !university) {
            alert("Please Fill all the details before submitting the form.");
            return;
        }
        e.preventDefault();
        // const form = document.getElementById('pre-departure-form');
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString(),
        })
            .then(() => {
                setStuName('');
                setEmail('');
                setDeparture('');
                setOrigin('');
                setDestination('');
                setUniversity('');
                navigate('/pre-departure-success');
            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Helmet>
                <title>Holistic Learning : Pre Departure Toolkit for Gulf Students</title>
                <meta name="description" content="Download your free Pre-Departure Toolkit for Gulf students. Visa checklist, packing guide, and cultural prep—all in one place." />
                <link rel="canonical" href="https://holisitclearning.com/gulf-students/pre-departure" />
            </Helmet>
            <section className="pre-departure-gulf-students-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-between">
                        <div className="col-md-6 pre-departure-gulf-students-heading-and-para-div">
                            <div className="pre-departure-gulf-students-heading-and-para-first-inner-div">
                                <h2><span>Pre-Departure </span>Toolkit for Gulf Students</h2>
                                <p>Get everything you need to prepare for your study abroad journey—visa checklists, packing guides, travel tips, and cultural prep—all in one place. Whether you're headed to the U.S., UK, Canada, Australia, or Europe, this toolkit is designed to help Gulf students arrive confident, organized, and ready to thrive. Download your free starter pack and take the stress out of departure planning. Your journey begins here.</p>
                            </div>
                        </div>
                        <div className="col-md-6 pre-departure-gulf-students-image-div">
                            <img src={GulfStudents2} alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="leaving-your-abroad-soon-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 leaving-your-abroad-soon-heading-div">
                            <h2><span>Leaving</span> for Abroad Soon?</h2>
                            <h4>This toolkit helps you prepare with confidence—covering everything from visa steps to cultural readiness. What’s inside:</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        {
                            PreDepartureToolkitData.map((item) => {
                                return (
                                    <div className="col-lg-3 col-md-6 col-sm-6 planning-to-study-abroad-card-div" key={item.id}>
                                        <div className="gulf-student-card-inner-div">
                                            <div className="what-we-offer-card-icon">
                                                <img src={item.bannerImg} alt="" />
                                            </div>
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
            <section className="why-it-matters-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 why-it-matters-heading-div">
                            <h2><span>Why</span> It Matters:</h2>
                            <div className="why-it-matters-card-inner-div">
                                <h4>Studying abroad isn’t just about boarding a flight—it’s about arriving prepared, confident, and ready to thrive. For Gulf students, the transition involves more than academics: it’s navigating new cultures, systems, and expectations. The Pre-Departure Toolkit bridges that gap. It helps you avoid last-minute stress, organize your documents, pack smart, and understand what to expect from day one. Because when you land prepared, you learn faster, connect deeper, and succeed sooner.</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact-now-access-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 contact-now-access-heading-div">
                            <h2><span>Contact Now</span> to Access</h2>
                        </div>
                        <div className="col-md-12 contact-now-form">
                            <form name="pre-departure-form" id="pre-departure-form" method="post" action="/pre-departure-success" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit={handleSubmit}>
                                <input type="hidden" name="form-name" value="pre-departure-form" />
                                <div className="row justify-content-center">
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" name='name' value={stuName} onChange={(e) => setStuName(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="departure" className="form-label">Departure Month</label>
                                        <input type="text" className="form-control" id="departure" name='departure' value={departure} onChange={(e) => setDeparture(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="origin" className="form-label">Origin Country</label>
                                        <input type="text" className="form-control" id="origin" name='origin' value={origin} onChange={(e) => setOrigin(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="destination" className="form-label">Destination Country</label>
                                        <input type="text" className="form-control" id="destination" name='destination' value={destination} onChange={(e) => setDestination(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="university" className="form-label">Intended University</label>
                                        <input type="text" className="form-control" id="university" name='university' value={university} onChange={(e) => setUniversity(e.target.value)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-button-div">
                                        <button type="submit">Get My Toolkit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="other-services-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 other-services-heading-div">
                            <h2>Other <span>Services</span></h2>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        {
                            GulfStudentsData.filter(item => item.id !== 1)
                                .map((item) => {
                                    return (
                                        <div className="col our-services-card-div" key={item.id}>
                                            <div className="our-services-card-inner-div">
                                                <div className="what-we-offer-card-icon">
                                                    <img src={item.bannerImg} alt="" />
                                                </div>
                                                <h5>{item.heading}</h5>
                                                <p>{item.text}</p>
                                                {item.link}
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </section>
            <TestimonialCard data={PreDepartureTestimonialData} title={<><span>Social</span> Proof</>} />
        </>
    )
}

export default PreDepartureToolKit